export default ({
  methods: {
    /* function validateCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g,'');

      if(cnpj == '') return false;

      if (cnpj.length != 14)
        return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
          cnpj == "11111111111111" ||
          cnpj == "22222222222222" ||
          cnpj == "33333333333333" ||
          cnpj == "44444444444444" ||
          cnpj == "55555555555555" ||
          cnpj == "66666666666666" ||
          cnpj == "77777777777777" ||
          cnpj == "88888888888888" ||
          cnpj == "99999999999999")
          return false;

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0,tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
        return false;

      return true;
    } */

    isValidCNPJ: function (cnpj) {
      const ncnpj = cnpj.replace(/[^\d]+/g, '')

      // Elimina CNPJs invalidos conhecidos
      if (ncnpj.length !== 14 ||
          ncnpj === '00000000000000' ||
          ncnpj === '11111111111111' ||
          ncnpj === '22222222222222' ||
          ncnpj === '33333333333333' ||
          ncnpj === '44444444444444' ||
          ncnpj === '55555555555555' ||
          ncnpj === '66666666666666' ||
          ncnpj === '77777777777777' ||
          ncnpj === '88888888888888' ||
          ncnpj === '99999999999999') {
        return false
      }

      // Valida DVs
      var tamanho = ncnpj.length - 2
      var numeros = ncnpj.substring(0, tamanho)
      var digitos = ncnpj.substring(tamanho)
      var soma = 0
      var pos = tamanho - 7

      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--

        if (pos < 2) {
          pos = 9
        }
      }

      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      var chatAtZero = parseInt(digitos.charAt(0))

      if (resultado !== chatAtZero) {
        return false
      }

      tamanho = tamanho + 1
      numeros = ncnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7

      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--

        if (pos < 2) {
          pos = 9
        }
      }

      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

      var chatAtOne = parseInt(digitos.charAt(1))

      if (resultado !== chatAtOne) {
        return false
      }

      return true
    },
  },
})
